import type { ReactNode } from "react";
import { cls } from "../format";

interface KpiCardProps {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
  tone?: "default" | "good" | "warn" | "bad" | "info";
}

export const KpiCard = ({ label, value, sub, tone = "default" }: KpiCardProps) => (
  <div className={cls("card", "kpi", `tone-${tone}`)}>
    <div className="card-label">{label}</div>
    <div className="card-value">{value}</div>
    {sub != null && <div className="card-sub">{sub}</div>}
  </div>
);
